export const ensureHighResTime = t => (
  // This is built to replace a missing or
  // old-style timestamp created via Date.now().
  // (to be perfect, this would need to check
  // against a new instance of Date.now(), minus
  // a safety theshold; as it stands, the window
  // would need to be open for a longer duration
  // than between the page load and 1970-1-1 for
  // this approximation not to work. The shortcut
  // is for performance reasons)
  t && t < performance.timing.navigationStart
    ? t
    : performance.now()
)

// Timer wrappers --------------------------------------------------------------

export class StackTimeout {
  constructor(f, delay, ...params) {
    this.f = f
    this.delay = delay
    this.params = params

    // Internal state
    this._running = false
    this._timeoutHandle = null
  }

  run() {
    if (!this._running) {
      this._timeoutHandle = window.setTimeout(
        this.f, this.delay,
        ...this.params
      )
      this._running = true
    } else {
      console.log('Cannot restart previously run timer')
    }
  }

  cancel() {
    window.clearTimeout(this._timeoutHandle)
  }
}

export class FrameTimeout {
  constructor(f, delay, ...params) {
    this.delay = delay
    this.f = f
    this.params = params

    // Internal state
    this._running = false
    this._timeoutHandle = null
    this._animationFrameHandle = null
    this._lastAnimationFrame = null

    // Timing mode
    this.mode = 'closest'

    // Bind tick method
    this.tick = this.tick.bind(this)
  }

  tick(frameTime=null) {
    const interval = this.targetTime - (frameTime || performance.now())

    // Calculate
    let threshold
    if (this._lastAnimationFrame && this.mode === 'undershoot') {
      // Undershoot: Fire function if the next rAF call
      // is likely to be after the target time
      threshold = this._lastAnimationFrame - interval
    } else if (this._lastAnimationFrame && this.mode === 'closest') {
      // Closest: Overshoot or undershoot, depending
      // on what is closer to the target time
      threshold = (this._lastAnimationFrame - interval) / 2
    } else {
      // Overshoot as fallback: Fire function when the
      // target time has passed
      threshold = 0
    }

    if (interval <= threshold) {
      // Fire callback
      this.f(...this.params)
    } else if (interval < 200) {
      // Check again on next animationFrame
      // TODO: The implications of this need to be rethought:
      // right now, the code switches between stack-based
      // and frame-based timing at least 100ms before the
      // target time. This gives it 5-6 frames of rAF callbacks
      // to work with (at 60fps), and correspondingly less if
      // the system is under load. It's unclear whether this
      // is enough, or possibly creates too much load itself.
      // Maybe the last interval could be placed more
      // thoughtfully, or the interval halving replaced
      // by a smarter algorithm.
      this._animationFrameHandle = window.requestAnimationFrame(this.tick)
      this._lastAnimationFrame = interval
    } else {
      // Wait a little longer
      this._timeoutHandle = window.setTimeout(
        this.tick,
        interval / 2
      )
    }
  }

  run() {
    if (!this._running) {
      // Set target time in milliseconds
      this.targetTime = performance.now() + this.delay
      this.tick()
      this._running = true
    } else {
      console.log('Cannot restart previously run timer')
    }
  }

  cancel() {
    window.clearTimeout(this._timeoutHandle)
    window.cancelAnimationFrame(this._animationFrameHandle)
  }
}



// WEBPACK FOOTER //
// ./src/util/timing.js